var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8293 28.4637C30.8293 28.4637 29.381 29.8862 29.026 30.3033C28.4478 30.9203 27.7666 31.2116 26.8736 31.2116C26.7877 31.2116 26.6961 31.2116 26.6102 31.2059C24.91 31.0974 23.33 30.4347 22.145 29.8691C18.9049 28.3037 16.0598 26.0814 13.6955 23.2649C11.7434 20.9169 10.4382 18.746 9.57376 16.4151C9.04137 14.9926 8.84673 13.8843 8.9326 12.8389C8.98985 12.1704 9.24745 11.6163 9.7226 11.1421L11.6747 9.19401C11.9552 8.93121 12.2529 8.78839 12.5448 8.78839C12.9055 8.78839 13.1974 9.00548 13.3806 9.1883C13.3864 9.19401 13.3921 9.19972 13.3978 9.20544C13.747 9.53107 14.079 9.86813 14.4282 10.228C14.6057 10.4109 14.7889 10.5937 14.9721 10.7822L16.5349 12.3418C17.1417 12.9474 17.1417 13.5073 16.5349 14.1128C16.3689 14.2785 16.2086 14.4442 16.0426 14.6041C15.5617 15.0955 15.9395 14.7185 15.4414 15.1641C15.43 15.1755 15.4185 15.1812 15.4128 15.1927C14.9205 15.684 15.0121 16.1639 15.1151 16.4895C15.1208 16.5066 15.1266 16.5238 15.1323 16.5409C15.5387 17.5235 16.1112 18.449 16.9813 19.5516L16.9871 19.5573C18.5671 21.4997 20.2329 23.0136 22.0705 24.1734C22.3052 24.3219 22.5457 24.4419 22.7747 24.5561C22.9807 24.659 23.1754 24.7561 23.3414 24.8589C23.3643 24.8703 23.3872 24.8875 23.4101 24.8989C23.6047 24.996 23.7879 25.0417 23.9768 25.0417C24.452 25.0417 24.7497 24.7447 24.847 24.6475L25.9691 23.5277C26.1637 23.3335 26.4728 23.0993 26.8335 23.0993C27.1884 23.0993 27.4804 23.3221 27.6578 23.5163C27.6636 23.522 27.6636 23.522 27.6693 23.5277L30.8236 26.6756C31.4132 27.2583 30.8293 28.4637 30.8293 28.4637Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.aa866fd5a305f0de22feacb71f77f965.svg";
export { ForwardRef as ReactComponent };